export default __webpack_public_path__ + "static/media/Vanir Butcher Axe.ee550440.jpg";